export enum PaymentTermReference {
    DAYS_AFTER_DELIVERY = 'DAYS_AFTER_DELIVERY',
    DAYS_AFTER_NOMINATION = 'DAYS_AFTER_NOMINATION',
    DAYS_AFTER_INVOICE_DATE = 'DAYS_AFTER_INVOICE_DATE',
    PREPAYMENT = 'PREPAYMENT',
}
